var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavoriteFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 30,
    height: 30,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 2.449 2.246",
    fill: "#474F64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M1.83 0c0.17,0 0.325,0.07 0.437,0.182 0.112,0.112 0.182,0.267 0.182,0.437l0 1.01c0,0.17 -0.07,0.325 -0.182,0.437 -0.112,0.112 -0.267,0.182 -0.437,0.182l-1.212 0c-0.17,0 -0.325,-0.07 -0.437,-0.182 -0.112,-0.112 -0.182,-0.267 -0.182,-0.437l0 -1.01c0,-0.17 0.07,-0.325 0.181,-0.437 0.112,-0.112 0.267,-0.181 0.437,-0.181l1.212 0zm0.302 0.316c-0.078,-0.078 -0.185,-0.126 -0.302,-0.126l-1.212 0c-0.118,0 -0.225,0.048 -0.302,0.126 -0.078,0.078 -0.126,0.185 -0.126,0.302l0 1.01c0,0.118 0.048,0.225 0.126,0.302 0.078,0.078 0.185,0.126 0.302,0.126l1.212 0c0.118,0 0.225,-0.048 0.302,-0.126 0.078,-0.078 0.126,-0.185 0.126,-0.302l0 -1.01c0,-0.118 -0.048,-0.225 -0.126,-0.302zm-0.821 1.371c-0.048,0.048 -0.126,0.048 -0.174,0l-0.529 -0.529c-0.06,-0.067 -0.096,-0.156 -0.096,-0.253 0,-0.211 0.171,-0.382 0.382,-0.382 0.136,0 0.261,0.072 0.33,0.189 0.068,-0.117 0.194,-0.189 0.33,-0.189 0.211,0 0.382,0.171 0.382,0.382 0,0.097 -0.036,0.185 -0.096,0.253l-0.529 0.529z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteFill);
export default __webpack_public_path__ + "static/media/favorite-fill.38f65d452d48eb7e8c336fa613f8e449.svg";
export { ForwardRef as ReactComponent };